<template>
  <slot v-bind="{ closeModal, save, loading }"/>
</template>

<script>
import { FileApi } from '../../test-api/index.ts'
import bcSelectedStore from '@/frontapp/store/bcSelected'
import DocumentStore from '@/frontapp/mixins/DocumentStore'
import bcFileStore from '@/frontapp/store/bcFile'
import { mapStores } from 'pinia'
import Toast from '@/frontapp/mixins/actions/Toast'

const fileApi = new FileApi({}, '/api/v2')

export default {
  mixins: [DocumentStore],
  provide() {
    return {
      closeModal: this.closeModal,
    }
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapStores(bcSelectedStore, bcFileStore)
  },
  methods: {
    closeModal(close) {
      this.$store.commit('nette/updateControl', {
        controlName: 'editFilesTagsForm',
        data: false,
        key: 'showModal',
      })

      if (close) {
        close()
      }
    },
    async save(close) {
      const ids = []

      this.bcSelectedStore.listSelected.forEach((element) => {
        if (element.type !== 'file' && this.$route.matched[0].name !== 'BCFile') {
          return
        }

        ids.push(this.$route.matched[0].name === 'BCFile' ? element.id : element.file.id)
      })

      this.loading = true

      try {
        let response

        if (this.$formValues['frm-editFilesTagsForm-editFilesTagsForm-replace']) {
          response = await fileApi.fileReplaceTags({
            ids,
            tags: this.$formValues['frm-editFilesTagsForm-editFilesTagsForm-tags']
          })

        } else {
          response = await fileApi.fileUpdateTags({
            ids,
            tags: this.$formValues['frm-editFilesTagsForm-editFilesTagsForm-tags']
          })
        }

        const filesMap = new Map(response.data.map(file => [file.id, file]))

        // update tags in selected files
        if (this.$route.matched[0].name === 'BCFile') {
          this.bcFileStore.list.forEach((file) => {
            if (!filesMap.has(file.id)) {
              return
            }

            file.tags.splice(0, file.tags.length, ...filesMap.get(file.id).tags)
          })
          
        } else {
          this.bcDocumentStore.getFlattenDocument().forEach((element) => {
            if (element.type !== 'file' || !element.file || !filesMap.has(element.file.id)) {
              return
            }

            element.file.tags.splice(0, element.file.tags.length, ...filesMap.get(element.file.id).tags)
          })
        }

        close()

        this.$store.commit('nette/updateControl', {
          controlName: 'editFilesTagsForm',
          data: false,
          key: 'showModal',
        })

        this.$formValues['frm-editFilesTagsForm-editFilesTagsForm-tags'] = []

        Toast(
          'success',
          this.$t(this.$formValues['frm-editFilesTagsForm-editFilesTagsForm-replace'] ? 'Tags was successfully replaced.' : 'Tags was successfully added to files.')
        )

      } catch (e) {
        Toast(
          'error',
          this.$t('Something went wrong.')
        )
      }
      
      this.loading = false
    }
  },
}
</script>